import React, { memo } from 'react'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import Grid from 'transfix-ui/core/Grid'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { TRACKS_OPTIONS } from 'apps/marketplace/utils/constants/graphqlEquipment'
import { useCreateShipmentFormContext } from '../../../context'
import AdditionalOptionsFormSection from '../AdditionalOptionsFormSection'
import LoadUnloadFormSection from '../LoadUnloadFormSection'
import SecuringOptionsFormSection from '../SecuringOptionsFormSection'
import TrailerQualityFormSection from '../TrailerQualityFormSection'

export interface IDryVanFormSectionProps {}

const DryVanFormSection = memo<IDryVanFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control } = useCreateShipmentFormContext()

  return (
    <Grid container spacing={2} data-test='dry-van-form-section'>
      <Grid item xs={12} md={6} lg={3}>
        <SecuringOptionsFormSection />
        <ControlledSelect
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.tracks}`}
          SelectProps={{
            label: 'Tracks',
            placeholder: 'Select a Track',
            dataTest: 'tracks-field',
            options: TRACKS_OPTIONS,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TrailerQualityFormSection />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <LoadUnloadFormSection />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <AdditionalOptionsFormSection />
      </Grid>
    </Grid>
  )
})

export default DryVanFormSection
